export default __webpack_public_path__ + "static/media/user.9ec08b71.svg";